module.exports = __webpack_public_path__ + "img/zw.68bec67d.png";